import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Analytics from 'utils/analytics';
import CommonValues from 'resources/common-values';

export default CreateReactClass({
    displayName: 'batch-print-subjects',

    PropTypes: {
        batchOptionState: PropTypes.bool.isRequired,
        nextButtonAction: PropTypes.func,
        selectSubjects: PropTypes.func,
        subjectActive: PropTypes.String,
        subjectBid: PropTypes.instanceOf(Immutable.Map).isRequired,
    },

    getInitialState() {
        return {
            selectedSubjectsForPrinting: Immutable.Set.of(this.props.subjectActive),
            selectedSubjectBidsForPrinting: Immutable.Set.of(this.props.subjectBid),
        };
    },

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.subjectActive !== this.props.subjectActive) {
            this.setState({
                selectedSubjectsForPrinting: Immutable.Set.of(nextProps.subjectActive),
                selectedSubjectBidsForPrinting: Immutable.Set.of(nextProps.subjectBid),
            });
            this.props.selectSubjects(
                Immutable.Set.of(nextProps.subjectActive),
                Immutable.Set.of(nextProps.subjectBid)
            );
        }
        if (!nextProps.batchOptionState) {
            this.reset();
        }
    },

    reset() {
        this.setState(this.getInitialState());
    },

    subjectCheckbox(subject) {
        return (
            <div className="batch-option" key={subject.get('bid')}>
                <input
                    type="checkbox"
                    id={`batch-print-${subject.get('shortName')}`}
                    checked={this.state.selectedSubjectsForPrinting.includes(
                        subject.get('description'),
                        subject.get('bid')
                    )}
                    onChange={(event) =>
                        this.toggleSubjectChange(event, subject.get('description'), subject.get('bid'))
                    }
                />
                <label htmlFor={`batch-print-${subject.get('shortName')}`}>{subject.get('description')}</label>
            </div>
        );
    },

    toggleSubjectChange(event, subject, subjectBid) {
        let subjects = this.state.selectedSubjectsForPrinting;
        let subjectBids = this.state.selectedSubjectBidsForPrinting;

        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, 'select-subjects', subject);

        if (subjects.includes(subject)) {
            subjects = subjects.delete(subject);
            subjectBids = subjectBids.delete(subjectBid);
        } else {
            subjects = subjects.add(subject);
            subjectBids = subjectBids.add(subjectBid);
        }
        this.setState({
            selectedSubjectsForPrinting: subjects,
            selectedSubjectBidsForPrinting: subjectBids,
        });
        this.props.selectSubjects(subjects, subjectBids);
    },

    render() {
        const containerClass =
            'button-container' + (this.state.selectedSubjectsForPrinting.size == 0 ? ' show-tooltip' : '');
        const tooltip = <div className="tooltip">No subject selected</div>;
        const arrow = <div className="tooltip arrow" />;

        let subjectsCheckboxes = CommonValues.subjects.map((subject) => this.subjectCheckbox(subject));

        return (
            <div className="subjects options-container">
                <div>
                    <h4>SELECT SUBJECTS</h4>
                    {subjectsCheckboxes}
                </div>
                <div className={containerClass}>
                    <button
                        className="button-next"
                        onClick={(event) => this.props.nextButtonAction(event, 'data')}
                        disabled={this.state.selectedSubjectsForPrinting.size == 0}
                    >
                        NEXT
                    </button>
                    {tooltip}
                    {arrow}
                </div>
            </div>
        );
    },
});
